module.exports = __webpack_public_path__ + "img/modal.818635ea.svg";